import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { PanelConfig } from '../types/panelConfig';

export function usePanelConfig() {
  return useQuery<PanelConfig>({
    queryKey: ['panelConfig'],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const { data } = await apiClient.get('/api/v2/panel/config', {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      return data;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
    retry: 2,
  });
}
